import React from 'react';
import PropTypes from 'prop-types';

import './styles.less';

const HeadlineStack = (props) => {
    return (
        <div className="p-headline-stack" data-content-id={props.contentId}>
            <ul className="p-headline-stack__list p-text-list p-text-list--unstyled">
                {props.items.map((item, i) => {
                    return (
                        <li key={i} className="p-headline-stack__headline">
                            <a className="p-headline-stack__link" href={item.url} data-content-id={item.contentId}>
                                {item.title}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

HeadlineStack.propTypes = {
    contentId: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            contentId: PropTypes.string,
            title: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired
        })
    ).isRequired
};

HeadlineStack.defaultProps = {
    contentId: undefined
};

export default HeadlineStack;
